import { useSelector } from "react-redux"
import NotificationComponent from "../components/notifications/NotificationComponent"

const ErrorContainer = () => {
    const errors = useSelector(state => state.notification.notifications)
    return <>
        {errors && errors.length > 0 && <NotificationComponent  data={errors}/>}
    </>
}

export default ErrorContainer